// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import dueDateWarningIconSrc from './due-date-warning-icon.svg';

type Props = {|
  message: string,
|}

export function DueDateWarning({ message }: Props ): Node {

  return (
    <Root>
      <Wrapper>
        <Icon src={dueDateWarningIconSrc} alt="due date icon" />
        <Message>
          {message}
        </Message>
      </Wrapper>
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  color: ${props => props.theme.colors.secondary(30)};
  width: 50%;
  height: 50%;
  display: flex;
  flex-direction: column;
  margin-top: 0.6em;

  @media (min-width: 840px) {
    width: auto;
    justify-content: space-around;
    flex-grow: 1;
    align-items: flex-start;
    margin-top: 20px;
  }
`;

const Wrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.feedback.warning[100]};
  color: ${props => props.theme.colors.neutral[900]};
  @media (min-width: 840px) {
    margin-left: 0;
  }
`;

const Icon = styled.img`
  margin-left: 8px;
  margin-top: 8px;
  padding: 8px;
  margin-right: 2px;
  margin-bottom: 8px;
`;

const Message = styled.p`
  margin-top: 2px;
  margin-right: 16px;
`;
